import { QueryOptions } from "../components/Common/useQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import { TransportDto } from "./useGetTransports";

const useGetSiteTransports = (siteId: string, options?: QueryOptions<TransportDto[]>) => {
  const business = useSelectedBusiness();
  return useUserQuery<TransportDto[]>({
    path: `/api/businesses/${business.id}/transports/siteTransports?siteId=${siteId}`,
  }, options);
}

export default useGetSiteTransports;
